// extracted by mini-css-extract-plugin
module.exports = {"container":"FlowCard_container__H2TDZ","title":"FlowCard_title__5tPX2","subtitle":"FlowCard_subtitle__s0NyU","badge":"FlowCard_badge__4pRTQ","arrow":"FlowCard_arrow__fd31S"};